import DOMPurify from 'dompurify';

/**
 * Sanitize untrusted HTML before rendering via dangerouslySetInnerHTML.
 * Uses DOMPurify with the standard HTML profile, which blocks script/iframe/
 * event handlers, SVG-embedded scripts, javascript:/vbscript:/data: URI
 * payloads, <base>/<meta>/<link> injection and similar XSS vectors.
 */
export function sanitizeHtml(html: string): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'base', 'meta', 'link', 'form'],
    FORBID_ATTR: ['style', 'srcset', 'formaction', 'action'],
  });
}
